import type { IUser } from "@/models/users";

export default {
  computed: {
    loggedUser(): IUser {
      return this.$store.state.user;
    }
  }
};
